import React from 'react';
import { useApp } from '../../context/AppContext';

const ToastContainer = () => {
  const { toasts, removeToast } = useApp();
  
  if (!toasts.length) return null;
  
  return (
    <div className="toast-container">
      {toasts.map(toast => (
        <div key={toast.id} className={`toast toast-${toast.type}`} onClick={() => removeToast(toast.id)}>
          {toast.message}
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
